import { every, includes, some } from 'lodash'
import getField from '@/utils/getField'

export function createSearchString (obj) {
  if (obj === null || obj === undefined) {
    return null
  }
  if (arguments.length < 2) {
    return JSON.stringify(obj)
  }
  const searchValues = new Set()
  for (let i = 1; i < arguments.length; i++) {
    const value = getField(obj, arguments[i])
    if (value !== null && value !== undefined) {
      searchValues.add(('' + value).trim().toLowerCase())
    }
  }
  return Array.from(searchValues).join(' ')
}

/**
 * Filtered By FreeSearch.
 *
 * @param freeSearch
 * @param filteredItems
 * @param [isFullMatchMode]
 * @returns {Array}
 */
export function filteredByFreeSearch (freeSearch, filteredItems, isFullMatchMode) {
  // default match mode
  if (isFullMatchMode === undefined) {
    isFullMatchMode = true
  }
  const substrings = (freeSearch && freeSearch.toLowerCase().split(' ').filter(s => s.length > 0)) || []
  filteredItems = filteredItems.filter(filteredItem => {
    return isFullMatchMode
      ? every(substrings, (el) => includes(filteredItem.searchString, el))
      : some(substrings, (el) => includes(filteredItem.searchString, el))
  })
  return filteredItems
}
